import React from 'react';

import {
  MinusSquareOutlined,
  CloseSquareTwoTone,
  CheckSquareTwoTone,
  SyncOutlined,
} from '@ant-design/icons';
import ErrorLabel from '@ui-library/errorLabel';
import { useTransition, animated } from 'react-spring';
import { FixMe } from '@utils/types';

interface Props {
  status: string;
  stepInfo?: FixMe;
}
const StepValidateSource = (data: Props) => {
  const transition = useTransition(data.stepInfo, {
    from: { opacity: 0 },
    enter: { opacity: 100 },
  });
  const transition2 = useTransition(data.stepInfo, {
    from: { opacity: 0, transform: 'translate3d(0,100%,0)' },
    enter: { opacity: 100, transform: 'translate3d(0,0,0)' },
    delay: 200,
  });
  const statusIcon = (val: string) => {
    switch (val) {
      case 'loading':
        return (
          <span>
            {transition((styles) => (
              <animated.div style={{ fontWeight: 'bold', ...styles }}>
                <h1>
                  {' '}
                  <SyncOutlined spin /> {data.stepInfo?.name}
                </h1>
              </animated.div>
            ))}
          </span>
        );
      case 'hide':
        return null;
      case 'passed':
        return (
          <div>
            {transition((styles) => (
              <animated.h1 style={{ color: '#27ae5f', ...styles }}>
                {' '}
                <CheckSquareTwoTone twoToneColor="#27ae5f" /> {data.stepInfo?.name}{' '}
              </animated.h1>
            ))}
          </div>
        );
      case 'failed':
        return (
          <div>
            <span>
              {' '}
              {transition((styles) => (
                <animated.h1 style={{ color: '#ca3434', fontWeight: 'bold', ...styles }}>
                  {' '}
                  <CloseSquareTwoTone twoToneColor="#CA4139" /> {data.stepInfo?.name}
                </animated.h1>
              ))}
              {transition2((styles) => (
                <animated.div style={styles}>
                  {' '}
                  <ErrorLabel
                    error
                    errorMessage={data.stepInfo?.error}
                    background="#f3d2d2"
                    padding="10px"
                  />{' '}
                </animated.div>
              ))}
            </span>
          </div>
        );
      case 'list':
        return (
          <h1>
            <MinusSquareOutlined /> {data.stepInfo?.name}
          </h1>
        );
      default:
        return null;
    }
  };

  return <div style={{ display: 'flex' }}>{statusIcon(data.status)}</div>;
};

export default StepValidateSource;
